import { render, staticRenderFns } from "./BasicinfoMyPage.vue?vue&type=template&id=47055c24&scoped=true&"
import script from "./BasicinfoMyPage.vue?vue&type=script&lang=js&"
export * from "./BasicinfoMyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew2_mypage.css?vue&type=style&index=0&lang=css&"
import style1 from "./BasicinfoMyPage.vue?vue&type=style&index=1&id=47055c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47055c24",
  null
  
)

export default component.exports